(function () {
  'use strict';

  angular.module('app').component('hotelCostDetail', hotelCostDetail());

  function hotelCostDetail() {
    return {
      bindings: {
        hotelCosts: '=',
        hotel: '<',
        seasonSelected: '<',
        priceListSelected: '<',
        provider: '<',
        onHotelCostsSaved: '&',
        onHotelCostsCanceled: '&',
        getAssociatedProvidersOnSave: '<',
      },
      controller: HotelCostDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotel-costs/hotel-cost-detail/hotel-cost-detail.component.html',
    };
  }

  HotelCostDetailComponent.$inject = ['CONFIGURATIONS', 'UtilService', 'HotelCostService'];

  function HotelCostDetailComponent(config, UtilService, HotelCostService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.saveHotelCosts = saveHotelCosts;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.hotelCosts.length > 0) {
        // Edit and exists costs
        setItemOptions(vm.hotelCosts[0].updated_at);
      } else {
        // Create
        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_COSTS';
      }

      setHotelCostsData();
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_COSTS';
    }

    function setHotelCostsData() {
      vm.hotelCostsData = [];

      vm.hotel.hotel_rooms.forEach(function (hotelRoom) {
        if (hotelRoom.status === 'active') {
          var hotelCostId;
          var singleCost = '',
            doubleCost = '';
          var tripleCost = 0,
            quadrupleCost = 0,
            additionalPersonCost = 0,
            childCost = 0;
          var hotelCost;

          // Exist hotel costs
          if (vm.hotelCosts.length > 0) {
            for (var i = 0; i < vm.hotelCosts.length; i++) {
              hotelCost = vm.hotelCosts[i];

              if (hotelCost.hotel_room_id === hotelRoom.id) {
                hotelCostId = hotelCost.id;

                singleCost = hotelCost.single_cost;
                doubleCost = hotelCost.double_cost;
                tripleCost = hotelCost.triple_cost;
                quadrupleCost = hotelCost.quadruple_cost;
                additionalPersonCost = hotelCost.additional_person_cost;
                childCost = hotelCost.child_cost;
                break;
              }
            }
          }

          hotelCost = {
            room: {
              id: hotelRoom.id,
              name: hotelRoom.name,
              max_occupancy: hotelRoom.max_occupancy,
              children_allowed: hotelRoom.children_allowed,
              status: hotelRoom.status,
            },
            single_cost: singleCost,
            double_cost: doubleCost,
            triple_cost: tripleCost,
            quadruple_cost: quadrupleCost,
            additional_person_cost: additionalPersonCost,
            child_cost: childCost,
          };

          if (hotelCostId) {
            hotelCost.hotelCostId = hotelCostId;
          }

          vm.hotelCostsData.push(hotelCost);
        }
      });

      return vm.hotelCostsData;
    }

    function saveHotelCosts(isFormValid) {
      if (!isFormValid || vm.hotelCostsData.length === 0) {
        return;
      }

      var hotelCosts = [];

      vm.hotelCostsData.forEach(function (hotelCost) {
        var cost = {
          single_cost: hotelCost.single_cost || 0,
          double_cost: hotelCost.double_cost || 0,
          triple_cost: hotelCost.triple_cost || 0,
          quadruple_cost: hotelCost.quadruple_cost || 0,
          additional_person_cost: hotelCost.additional_person_cost || 0,
          child_cost: hotelCost.child_cost || 0,

          hotel_room_id: hotelCost.room.id,
          id: null,
        };

        if (hotelCost.hotelCostId) {
          cost.id = hotelCost.hotelCostId;
        }

        hotelCosts.push(cost);
      });

      let params = {
        hotel_costs: hotelCosts,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
        provider_id: vm.provider.id,
        get_associated_providers: null,
      };

      if (vm.getAssociatedProvidersOnSave) {
        params.get_associated_providers = true;
      }

      vm.sendingForm = true;
      HotelCostService.saveHotelCosts(vm.hotel, params, vm.editMode).then(function (data) {
        if (data) {
          let obj = vm.getAssociatedProvidersOnSave ? { dataObj: data.associated_providers } : {};

          vm.onHotelCostsSaved(obj);

          setItemOptions(data.hotel_costs[0].updated_at);

          vm.hotelCosts = data.hotel_costs;
          setHotelCostsData();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onHotelCostsCanceled();
    }
  }
})();
